import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ob-sosudov',
  templateUrl: './ob-sosudov.component.html',
  styleUrls: ['./ob-sosudov.component.scss']
})
export class ObSosudovComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
